/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  SupplierAddCompanyToSupplierParams,
  SupplierGetSupplierByCompanyParams,
  SupplierGetSupplierParams,
  SupplierModel,
  SupplierModelBody,
  SupplierRemoveCompanyFromSupplierParams,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useSupplierGetSuppliersHook = () => {
  const supplierGetSuppliers = useCustomInstance<SupplierModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return supplierGetSuppliers({
        url: `/api/Supplier/GetSuppliers`,
        method: 'GET',
        signal,
      });
    },
    [supplierGetSuppliers]
  );
};

export const getSupplierGetSuppliersQueryKey = () => {
  return [`/api/Supplier/GetSuppliers`] as const;
};

export const useSupplierGetSuppliersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSupplierGetSuppliersHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSupplierGetSuppliersHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSupplierGetSuppliersQueryKey();

  const supplierGetSuppliers = useSupplierGetSuppliersHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useSupplierGetSuppliersHook>>>
  > = ({ signal }) => supplierGetSuppliers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSupplierGetSuppliersHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SupplierGetSuppliersQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSupplierGetSuppliersHook>>>
>;
export type SupplierGetSuppliersQueryError = unknown;

export const useSupplierGetSuppliers = <
  TData = Awaited<ReturnType<ReturnType<typeof useSupplierGetSuppliersHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSupplierGetSuppliersHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useSupplierGetSuppliersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useSupplierGetSupplierByCompanyHook = () => {
  const supplierGetSupplierByCompany = useCustomInstance<SupplierModel>();

  return useCallback(
    (params?: SupplierGetSupplierByCompanyParams, signal?: AbortSignal) => {
      return supplierGetSupplierByCompany({
        url: `/api/Supplier/GetSupplierByCompany`,
        method: 'GET',
        params,
        signal,
      });
    },
    [supplierGetSupplierByCompany]
  );
};

export const getSupplierGetSupplierByCompanyQueryKey = (
  params?: SupplierGetSupplierByCompanyParams
) => {
  return [
    `/api/Supplier/GetSupplierByCompany`,
    ...(params ? [params] : []),
  ] as const;
};

export const useSupplierGetSupplierByCompanyQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useSupplierGetSupplierByCompanyHook>>
  >,
  TError = unknown,
>(
  params?: SupplierGetSupplierByCompanyParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useSupplierGetSupplierByCompanyHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSupplierGetSupplierByCompanyQueryKey(params);

  const supplierGetSupplierByCompany = useSupplierGetSupplierByCompanyHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useSupplierGetSupplierByCompanyHook>>>
  > = ({ signal }) => supplierGetSupplierByCompany(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSupplierGetSupplierByCompanyHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SupplierGetSupplierByCompanyQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSupplierGetSupplierByCompanyHook>>>
>;
export type SupplierGetSupplierByCompanyQueryError = unknown;

export const useSupplierGetSupplierByCompany = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useSupplierGetSupplierByCompanyHook>>
  >,
  TError = unknown,
>(
  params?: SupplierGetSupplierByCompanyParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useSupplierGetSupplierByCompanyHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useSupplierGetSupplierByCompanyQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useSupplierGetSupplierHook = () => {
  const supplierGetSupplier = useCustomInstance<SupplierModel>();

  return useCallback(
    (params?: SupplierGetSupplierParams, signal?: AbortSignal) => {
      return supplierGetSupplier({
        url: `/api/Supplier/GetSupplier`,
        method: 'GET',
        params,
        signal,
      });
    },
    [supplierGetSupplier]
  );
};

export const getSupplierGetSupplierQueryKey = (
  params?: SupplierGetSupplierParams
) => {
  return [`/api/Supplier/GetSupplier`, ...(params ? [params] : [])] as const;
};

export const useSupplierGetSupplierQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSupplierGetSupplierHook>>>,
  TError = unknown,
>(
  params?: SupplierGetSupplierParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useSupplierGetSupplierHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSupplierGetSupplierQueryKey(params);

  const supplierGetSupplier = useSupplierGetSupplierHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useSupplierGetSupplierHook>>>
  > = ({ signal }) => supplierGetSupplier(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSupplierGetSupplierHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SupplierGetSupplierQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSupplierGetSupplierHook>>>
>;
export type SupplierGetSupplierQueryError = unknown;

export const useSupplierGetSupplier = <
  TData = Awaited<ReturnType<ReturnType<typeof useSupplierGetSupplierHook>>>,
  TError = unknown,
>(
  params?: SupplierGetSupplierParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useSupplierGetSupplierHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useSupplierGetSupplierQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useSupplierAddSupplierHook = () => {
  const supplierAddSupplier = useCustomInstance<void>();

  return useCallback(
    (supplierModelBody: SupplierModelBody) => {
      return supplierAddSupplier({
        url: `/api/Supplier/AddSupplier`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: supplierModelBody,
      });
    },
    [supplierAddSupplier]
  );
};

export const useSupplierAddSupplierMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSupplierAddSupplierHook>>>,
    TError,
    { data: SupplierModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useSupplierAddSupplierHook>>>,
  TError,
  { data: SupplierModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const supplierAddSupplier = useSupplierAddSupplierHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useSupplierAddSupplierHook>>>,
    { data: SupplierModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return supplierAddSupplier(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SupplierAddSupplierMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSupplierAddSupplierHook>>>
>;
export type SupplierAddSupplierMutationBody = SupplierModelBody;
export type SupplierAddSupplierMutationError = unknown;

export const useSupplierAddSupplier = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSupplierAddSupplierHook>>>,
    TError,
    { data: SupplierModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useSupplierAddSupplierHook>>>,
  TError,
  { data: SupplierModelBody },
  TContext
> => {
  const mutationOptions = useSupplierAddSupplierMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useSupplierUpdateSupplierHook = () => {
  const supplierUpdateSupplier = useCustomInstance<void>();

  return useCallback(
    (supplierModelBody: SupplierModelBody) => {
      return supplierUpdateSupplier({
        url: `/api/Supplier/UpdateSupplier`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: supplierModelBody,
      });
    },
    [supplierUpdateSupplier]
  );
};

export const useSupplierUpdateSupplierMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSupplierUpdateSupplierHook>>>,
    TError,
    { data: SupplierModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useSupplierUpdateSupplierHook>>>,
  TError,
  { data: SupplierModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const supplierUpdateSupplier = useSupplierUpdateSupplierHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useSupplierUpdateSupplierHook>>>,
    { data: SupplierModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return supplierUpdateSupplier(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SupplierUpdateSupplierMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSupplierUpdateSupplierHook>>>
>;
export type SupplierUpdateSupplierMutationBody = SupplierModelBody;
export type SupplierUpdateSupplierMutationError = unknown;

export const useSupplierUpdateSupplier = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSupplierUpdateSupplierHook>>>,
    TError,
    { data: SupplierModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useSupplierUpdateSupplierHook>>>,
  TError,
  { data: SupplierModelBody },
  TContext
> => {
  const mutationOptions = useSupplierUpdateSupplierMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useSupplierAddCompanyToSupplierHook = () => {
  const supplierAddCompanyToSupplier = useCustomInstance<void>();

  return useCallback(
    (params?: SupplierAddCompanyToSupplierParams) => {
      return supplierAddCompanyToSupplier({
        url: `/api/Supplier/AddCompanyToSupplier`,
        method: 'POST',
        params,
      });
    },
    [supplierAddCompanyToSupplier]
  );
};

export const useSupplierAddCompanyToSupplierMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSupplierAddCompanyToSupplierHook>>>,
    TError,
    { params?: SupplierAddCompanyToSupplierParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useSupplierAddCompanyToSupplierHook>>>,
  TError,
  { params?: SupplierAddCompanyToSupplierParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const supplierAddCompanyToSupplier = useSupplierAddCompanyToSupplierHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useSupplierAddCompanyToSupplierHook>>>,
    { params?: SupplierAddCompanyToSupplierParams }
  > = (props) => {
    const { params } = props ?? {};

    return supplierAddCompanyToSupplier(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type SupplierAddCompanyToSupplierMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSupplierAddCompanyToSupplierHook>>>
>;

export type SupplierAddCompanyToSupplierMutationError = unknown;

export const useSupplierAddCompanyToSupplier = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSupplierAddCompanyToSupplierHook>>>,
    TError,
    { params?: SupplierAddCompanyToSupplierParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useSupplierAddCompanyToSupplierHook>>>,
  TError,
  { params?: SupplierAddCompanyToSupplierParams },
  TContext
> => {
  const mutationOptions =
    useSupplierAddCompanyToSupplierMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useSupplierRemoveCompanyFromSupplierHook = () => {
  const supplierRemoveCompanyFromSupplier = useCustomInstance<void>();

  return useCallback(
    (params?: SupplierRemoveCompanyFromSupplierParams) => {
      return supplierRemoveCompanyFromSupplier({
        url: `/api/Supplier/RemoveCompanyFromSupplier`,
        method: 'POST',
        params,
      });
    },
    [supplierRemoveCompanyFromSupplier]
  );
};

export const useSupplierRemoveCompanyFromSupplierMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useSupplierRemoveCompanyFromSupplierHook>>
    >,
    TError,
    { params?: SupplierRemoveCompanyFromSupplierParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useSupplierRemoveCompanyFromSupplierHook>>
  >,
  TError,
  { params?: SupplierRemoveCompanyFromSupplierParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const supplierRemoveCompanyFromSupplier =
    useSupplierRemoveCompanyFromSupplierHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useSupplierRemoveCompanyFromSupplierHook>>
    >,
    { params?: SupplierRemoveCompanyFromSupplierParams }
  > = (props) => {
    const { params } = props ?? {};

    return supplierRemoveCompanyFromSupplier(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type SupplierRemoveCompanyFromSupplierMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useSupplierRemoveCompanyFromSupplierHook>>
  >
>;

export type SupplierRemoveCompanyFromSupplierMutationError = unknown;

export const useSupplierRemoveCompanyFromSupplier = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useSupplierRemoveCompanyFromSupplierHook>>
    >,
    TError,
    { params?: SupplierRemoveCompanyFromSupplierParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useSupplierRemoveCompanyFromSupplierHook>>
  >,
  TError,
  { params?: SupplierRemoveCompanyFromSupplierParams },
  TContext
> => {
  const mutationOptions =
    useSupplierRemoveCompanyFromSupplierMutationOptions(options);

  return useMutation(mutationOptions);
};
